module.exports = __webpack_public_path__ + "img/ic-project.dc77e835.svg";